import { useQuery } from '@tanstack/react-query';

import { formatDateToISO, normalizeToStartOfDayUTC } from '@/utils/date-formatters';
import { normalizeToEndOfDayUTC } from '@/utils/date-formatters/date-formatters';

import { getMonthOverview } from '../api/time-tracking.api';
import { TIME_TRACKING_QUERY_KEYS } from '../constants/time-tracking-query-keys';
import { ViewMode } from '../types/time-tracking';
import { getDateRangeForView } from './use-view-mode-and-date';

interface UseMonthOverviewParams {
  /** Any date inside the target month. */
  date: Date;
}

export const useMonthOverview = ({ date }: UseMonthOverviewParams) => {
  const { start, end } = getDateRangeForView(date, ViewMode.Month);
  const startDate = formatDateToISO(normalizeToStartOfDayUTC(start));
  const endDate = formatDateToISO(normalizeToEndOfDayUTC(end));

  return useQuery({
    queryKey: TIME_TRACKING_QUERY_KEYS.monthOverview(startDate, endDate),
    queryFn: () => getMonthOverview(startDate, endDate),
    staleTime: 1000 * 60 * 5,
  });
};
